import React from "react";
import './table-date.component.scoped.sass';
import { useTranslation } from "react-i18next";
import { tableDate } from "../../helpers";

export const TableDateComponent = ({ date }: any) => {
  const [t] = useTranslation();
  const { week, outputDay, formatedDate } = tableDate(date)
  return (
    <div className="date-col">
      <div className="week">{t('cw')} {week}</div>
      <div className="day">{outputDay}, {formatedDate}</div>
    </div>
  );
};
